import Vue from 'vue'
import Router from 'vue-router'
import LoggedArea from '@/pages/loggedArea/LoggedArea'
import GuestArea from '@/pages/guestArea/GuestArea.vue'
import cadastrarSenha from "@/pages/guestArea/novoUsuario/NovoUsuario.vue"
import InformeRendimentos from '@/pages/loggedArea/informeRendimentos/InformeRendimentos.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/DashBoard',
      name: 'DashBoard',
      component: LoggedArea
    },
    {
      path: '/',
      name: 'Login',
      component: GuestArea
    },
    {
      path: '/cadastrar',
      name: 'Cadastro',
      component: GuestArea
    },
    {
      path: '/login',
      name: 'Login',
      component: GuestArea
    },
    {
      path: '/consultaNFe',
      name: 'Consulta NF-e',
      component: LoggedArea
    },
    {
      path: '/consultaIptu',
      name: 'Consulta IPTU',
      component: LoggedArea
    },
    {
      path: '/consultaCTe',
      name: 'Consulta CT-e',
      component: LoggedArea
    },
    {
      path: '/ePerfil',
      name: 'Editar Perfil',
      component: LoggedArea
    },
    {
      path: '/relatorio',
      name: 'Relatório',
      component: LoggedArea
    },
    {
      path: '/validaOcr',
      name: 'Valida OCR',
      component: LoggedArea
    },
    {
      path: '/verPerfil',
      name: 'Ver Perfil',
      component: LoggedArea
    },
    {
      // consultaNFSe
      path: '/consultaNFSe',
      name: 'Consulta NFS-e',
      component: LoggedArea
    },
    {
      path: '/fornecedores',
      name: 'Consulta Fornecedores',
      component: LoggedArea
    },
    {
      path: '/clientes',
      name: 'Consulta Clientes',
      component: LoggedArea
    },
    {
      path: '/produtos',
      name: 'Consulta Produtos',
      component: LoggedArea
    },
    {
      path: '/configuracoes',
      name: 'Configurações',
      component: LoggedArea
    },
    {
      path: '/configuracoesAutomacao',
      name: 'ConfiguraçõesAutomacao',
      component: LoggedArea
    },
    {
      path: '/nvusuario/:token',
      name: 'Cadastro de usuário',
      component: cadastrarSenha
    },
    {
      path: '/primeiroAcesso',
      name: 'Primeiro Acesso',
      component: LoggedArea
    },
    {
      path: '/fechamento',
      name: 'Fechamento de Mês',
      component: LoggedArea
    },
    {
      path: '/loja',
      name: 'Loja',
      component: LoggedArea
    },
    {
      path: '/download/fechamentoMensal',
      name: 'Download - Fechamento Mensal',
      component: GuestArea
    },
    {
      path: '/docsFederal',
      name: 'Docs Federal',
      component: LoggedArea
    },
    {
      path: '/docsMunicipal',
      name: 'Docs Municipal',
      component: LoggedArea
    },
    {
      path: '/informe-rendimentos/:token',
      name: 'Informe Rendimentos',
      component: InformeRendimentos
    },

    { path: "*", component: LoggedArea }

  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js